import React, { FC } from 'react';

import { UniqueIssuesData } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';
import { ScoreData } from 'src/apps/dashboard/services/queries/score/helpers/transformResults';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';

import { AccessibilitySummary } from './components/accessibility_summary/AccessibilitySummary';
import { AccessibilitySummarySkeleton } from './components/accessibility_summary_skeleton/AccessibilitySummarySkeleton';

interface AccessibilitySummaryContainerProps {
	className?: string;
	scoreData?: ScoreData[];
	uniqueIssuesData?: UniqueIssuesData;
	totalIssuesData?: UniqueIssuesData;
	isLoading?: boolean;
	error?: unknown;
	isUniquenessServiceEnabled?: boolean;
	filters?: IFilterOptions;
}

export const AccessibilitySummaryContainer: FC<AccessibilitySummaryContainerProps> = ({
	className = '',
	scoreData,
	uniqueIssuesData,
	totalIssuesData,
	isLoading,
	error,
	isUniquenessServiceEnabled,
	filters
}) => {
	if (isLoading) {
		return <AccessibilitySummarySkeleton />;
	}

	if (error) {
		return null;
	}

	return (
		<AccessibilitySummary
			scoreData={scoreData}
			uniqueIssuesData={uniqueIssuesData}
			totalIssuesData={totalIssuesData}
			className={className}
			isUniquenessServiceEnabled={isUniquenessServiceEnabled}
			filters={filters}
		/>
	);
};
